<template>
  <div>
    <v-col v-if="!content[wtype]" cols="12" :class="[{ 'disable': !!session.cancelled }]">
      <div v-if="isParticipant(wtype)">
        <AddParticipantModal
          v-if="canUserPerformAction"
          :session="session"
          :index="index"
          :participant-horse-list.sync="participantHorseList"
        />
        <div v-else class="text-start">
          <span>N/A</span>
        </div>
      </div>

      <TablePopUp
        v-else-if="canUserPerformAction"
        v-model="newValue"
        class="mr-1"
        :single-select="true"
        :index="index"
        direction="bottom"
        :list="notSelectedList"
        :icon="icon"
        :field="contentTypeField"
        :wtype="wtype"
        :session-field="`${wtype}s`"
        :participant-horse-list.sync="participantHorseList"
        :update-session="updateSession"
        :update-participant-horse-list="true"
        width="550"
        :session="session"
        :content-type-id-field="field"
        :disabled="isContentDisable() || !canUserPerformAction"
      />
      <div v-else class="text-start">
        <span>N/A</span>
      </div>
    </v-col>
    <v-col v-else cols="12" :class="[{ 'disable': !!session.cancelled }, 'd-flex align-center']">
      <div
        :draggable="!!content[wtype] && !session.cancelled"
        :class="['d-flex align-center col-5 px-0', { 'grab': !!content[wtype] }, { 'pointer': !content[wtype] }, { 'col-7': !isParticipant(wtype) && numberOfClubParticipants > 0 }]"
        @dragstart="dragStartPickers($event, content[wtype], wtype, index)"
        @drop="drop($event, content[wtype], wtype, index)"
        @dragover.prevent
      >
        {{ label(content[wtype], contentTypes, contentTypeField) }}
        <v-icon v-if="validParticipantPage" class="ml-2" @click="redirectParticipantPage(content)">mdi-information-variant-circle-outline</v-icon>
        <!-- <div v-if="isParticipant(wtype) && paymentStatusColor(content[wtype], contentTypes, 'paymentColor')" class="box-payment-status ml-2" :style="paymentStatusColor(content[wtype], contentTypes, 'paymentColor')"></div> -->
      </div>
      <v-col v-if="isParticipant(wtype)" cols="2">
        {{ customerAge(content[wtype], contentTypes, 'age') }}
      </v-col>
      <v-col v-if="!isParticipant(wtype)" cols="2">
        <div class="light-pink-bg">
          {{ contentTypeDailyEffort(content[wtype]).dailyEffort }}
        </div>
      </v-col>

      <div>
        <v-btn v-if="wtype === 'horse' && sessionTypesAllowInsertEffort.includes(session.type) && canUserPerformAction" icon :disabled="!canUserPerformAction">
          <v-icon icon @click="openHorseEffortModal(content[wtype])">
            mdi-horseshoe
          </v-icon>
        </v-btn>
      </div>
      <div v-if="isParticipant(wtype) && canUserPerformAction" class="d-flex col-4 justify-space-between px-0">
        <TransferTable :session="session" :participant="content[wtype]" />
        <v-tooltip top>
          <template #activator="{ on, attrs }">
            <v-btn icon :disabled="!canUserPerformAction" v-bind="attrs" v-on="on" @click="setPresenceContent(content, 'present')">
              <v-icon color="black" icon>
                mdi-account-check-outline
              </v-icon>
            </v-btn>
          </template>
          <span>Présent</span>
        </v-tooltip>
        <v-tooltip top>
          <template #activator="{ on, attrs }">
            <v-btn icon :disabled="!canUserPerformAction" v-bind="attrs" v-on="on" @click="setPresenceContent(content, 'absent')">
              <v-icon color="black" icon>
                mdi-account-cancel-outline
              </v-icon>
            </v-btn>
          </template>
          <span>Absent</span>
        </v-tooltip>
      </div>
      <v-btn v-if="canUserPerformAction" icon :disabled="!canUserPerformAction">
        <v-icon color="black" :class="[{ 'disable': !!session.cancelled }]" @click="handleDelete">
          mdi-minus-circle-outline
        </v-icon>
      </v-btn>
    </v-col>
    <SessionEditOverlay
      v-if="session.recurring"
      style="z-index: 205;"
      :activator.sync="showConfirmationModal"
      :change-confirmation-modal="changeEditSessionOverlay"
      :change-recurring-session="deleteContent"
      :options="editOverlayOptions"
    />
    <v-dialog v-model="isHorseEffortOpen" width="500">
      <v-card>
        <v-card-title class="third d-flex justify-center white--text">Cheval: {{ label(content[wtype], contentTypes, contentTypeField) }}</v-card-title>
        <v-card-text class="mt-4">
          <v-form v-model="effortValid">
            <v-text-field
              v-model="manualHorseEffort"
              label="Effort du cheval"
              type="number"
              color="third"
              outlined
              :rules="effortRules"
            />
          </v-form>
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn class="third--text" :disabled="loading" text @click="closeHorseEffortModal">Close</v-btn>
          <v-btn v-if="canUserPerformAction" class="third--text" text :disabled="!effortValid || !canUserPerformAction" :loading="loading" @click="addManualEffort(content[wtype])">Confirmer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ProductRecuperationModal
      v-if="presenceConfirmationModal"
      :show="presenceConfirmationModal"
      :selected-participant="selectedParticipant"
      :session="session"
      :presence-status="presenceStatus"
      @closeModal="closePresenceConfirmationModal"
    />
    <RestoreStock
      v-if="restoreStockModal"
      :show="restoreStockModal"
      :selected-participant="content"
      :session="session"
      :typeOfupdate="typeOfupdate"
      :totalRecurringSessions="sessionsToRestoreStock.totalSessions"
      :totalStockToRestore="sessionsToRestoreStock.totalStockToRestore"
      @participantRemoval="deleteContent(true)"
      @closeModal="closeRestoreStockModal"
    />
  </div>
</template>

<script>
import { computed, ref, watch, inject, provide } from '@vue/composition-api';
import { differenceInHours, isBefore } from 'date-fns';
import { minutesToHours, sendNotification, deleteOptions, stageRadioOptions, dragStartPickers, dropPickers, changePresenceInSession } from '@/helpers/utils';
import { deleteContentsFromSession, updateSessionAmplify } from '@/helpers/amplify';
import { filterHorse, sessionTypesAllowInsertEffort, computeEffort } from '@/helpers/dataManager';
import { presenseStatus } from '@/helpers/variables';
import { sessionsWithPeriods, constructSessionsBag, recurringHorseAssignSessions } from '@/helpers/sessions';
import TablePopUp from '../TablePopUp.vue';
import AddParticipantModal from './AddParticipantModal.vue';
import SessionEditOverlay from '../sessions/createForm/SessionEditOverlay.vue';
import TransferTable from '@/components/sessions/TransferTable.vue';
import ProductRecuperationModal from '@/components/customer/ProductRecuperationModal.vue';
import RestoreStock from '@/components/customer/RestoreStock.vue';

import store from '@/store';

export default {
  components: { TablePopUp, AddParticipantModal, SessionEditOverlay, TransferTable, ProductRecuperationModal, RestoreStock },
  props: {
    value: {
      type: Array,
      default () {
        return [];
      }
    },
    content: {
      type: Object,
      default () {
        return {};
      }
    },
    wtype: {
      type: String,
      default: ''
    },
    contentTypeField: {
      type: String,
      default: ''
    },
    available: {
      type: Array,
      default () {
        return [];
      }
    },
    session: {
      type: Object,
      default () {
        return {};
      }
    },
    icon: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: -1
    },
    contentTypes: {
      type: Array,
      default () {
        return [];
      }
    },
    field: {
      type: String,
      default: null
    },
    numberOfClubParticipants: {
      type: Number,
      default: 0
    }
  },
  setup (props, context) {
    const newValue = ref(props.value);

    const horses = computed(() => store.state.horses);
    const typeOfupdate = ref('SINGLE');
    const session = ref(props.session);

    const horseWithoutParticipant = ref(null);
    const selectedHorseTypes = ref([]);
    const selectedLevels = ref([]);

    const isItemHorse = computed(() => props.wtype === 'horse');

    const isHorseEffortOpen = ref(false);
    const manualHorseEffort = ref('');
    const selectedHorse = ref('');

    const effortValid = ref(false);

    const loading = ref(false);
    const presenceConfirmationModal = ref(false);
    const selectedParticipant = ref({});
    const presenceStatus = ref('');

    const restoreStockModal = ref(false);
    const sessionsToRestoreStock = ref({
      totalSessions: 0,
      totalStockToRestore: 0
    });
    const sessionsToUpdate = ref([]);

    const sessionPresenceChanged = async () => {
      const updatedSession = changePresenceInSession(selectedParticipant.value, session.value, presenceStatus.value);

      if (!updatedSession.updated) {
        return;
      }

      await updateSessionAmplify(updatedSession.session);
      presenceConfirmationModal.value = false;

      sendNotification('success', 'Présence mise à jour avec succès');
    };

    provide('typeOfupdate', typeOfupdate);
    provide('selectedIndex', props.index);
    provide('oldSessionDetail', session);
    provide('newSession', session);

    provide('horseWithoutParticipant', horseWithoutParticipant);
    provide('selectedHorseTypes', selectedHorseTypes);
    provide('levelsList', selectedLevels);

    const participantHorseList = inject('participantHorseList');
    const updateSession = inject('updateSession');
    const isComponentLoading = inject('isComponentLoading');
    const showConfirmationModal = ref(false);

    /* TODO: Avoid infinite loop */
    // watch(newValue, () => {
    //   context.emit('input', newValue.value);
    // });

    watch(() => props.value, () => {
      newValue.value = props.value;
    });

    const updateEffort = uuid => {
      const horse = session.value.horses.find(h => h.uuid === uuid);
      if (horse) {
        manualHorseEffort.value = horse.effort;
      }
    };

    watch(() => props.session, () => {
      session.value = props.session;
      updateEffort(selectedHorse.value);
    });

    const changeEditSessionOverlay = value => {
      showConfirmationModal.value = value;
    };

    const notSelectedList = computed(() => {
      const notSelected = [...props.available];

      if (!isItemHorse.value) {
        // for each already selected (horse/participant) remove from not select list
        newValue.value.map(contentType => {
        // remove selected contentType from notselected array
          const index = notSelected.findIndex(h => h.uuid === contentType.uuid);
          if (index !== -1) {
            notSelected.splice(index, 1);
          }
        });

        return notSelected;
      }

      let indexToRemove = [];

      notSelected.map((horse, horseIndex) => {
        const horseHaveParticipant = (props.session.participants || []).some(p => p.horse === horse.uuid);

        if (horseHaveParticipant) {
          const index = notSelected.findIndex(h => h.uuid === horse.uuid);

          if (index !== -1) {
            indexToRemove.push(horseIndex);
          }
        }
      });

      indexToRemove = indexToRemove.sort((a, b) => (a < b ? -1 : 1));
      for (let i = indexToRemove.length - 1; i >= 0; i -= 1) {
        notSelected.splice(indexToRemove[i], 1);
      }

      return filterHorse(notSelected, horseWithoutParticipant.value, props.session, selectedHorseTypes.value, null, selectedLevels.value);
    });

    const drop = (event, dropId, wtype, index) => {
      const { updatedArray, success } = dropPickers(event, dropId, wtype, participantHorseList.value, session.value, index);
      if (success) {
        participantHorseList.value = updatedArray;
        updateSession();
      }
    };

    const deleteParticipantHorsePair = () => {
      if (!store.getters.canUserPerformAction) {
        return;
      }
      const value = participantHorseList.value[props.index];
      const typeToLook = props.wtype === 'horse' ? 'participant' : 'horse';
      // remove from array, ex: remove horse from selected horse list
      const indexToRemove = newValue.value.findIndex(v => v.uuid === value[props.wtype]);
      newValue.value.splice(indexToRemove, 1);
      // remove horse but list still have participant so remove only the horse
      if (value[typeToLook]) {
        participantHorseList.value[props.index][props.wtype] = null;
        updateSession();
        return;
      }
      // remove horse and list don't have participant so remove the line
      participantHorseList.value.splice(props.index, 1);
      updateSession();
    };
    
    const validParticipantPage = computed(() => isParticipant(props.wtype) && !props.content.isGuest);

    const redirectParticipantPage = content => {
      const uuid = content.participant || content.uuid;
      window.open(`/customer/${uuid}`, '_blank');
    };

    const isParticipant = wtype => wtype === 'participant';

    const isClubParticipant = computed(() => isParticipant(props.wtype) && props.content.isClubParticipant && !props.content.contractOwner);

    const isPastSession = computed(() => isBefore(new Date(props.session.end_time * 1000), new Date()));

    const canDeleteHorsesRecurring = computed(() => recurringHorseAssignSessions.includes(props.session.type));

    const handleDelete = async () => {
      if (!store.getters.canUserPerformAction) {
        return;
      }

      if(isClubParticipant.value && isPastSession.value){
        restoreStockModal.value = true;
        sessionsToUpdate.value = [props.session];
        return;
      }

      if (props.session.recurring && ((props.wtype === 'horse' && canDeleteHorsesRecurring.value) || isParticipant(props.wtype))) {
        showConfirmationModal.value = true;
        return;
      }

      if(typeOfupdate.value === 'SINGLE' && props.wtype !== 'participant'){
        deleteParticipantHorsePair();
        return;
      }

      isComponentLoading.value = true;
      await deleteContentsFromSession(props.session, participantHorseList.value[props.index].participant, typeOfupdate.value, 'participants');
      isComponentLoading.value = false;
    };

    const label = (uuid, array, field) => {
      const contentType = array.find(val => val[props.field] === uuid);
      if (!contentType) {
        return null;
      }

      let label = contentType[field];

      if(contentType.isClubParticipant && contentType.contractOwner){
        label = `${label} (${props.numberOfClubParticipants + 1})`;
      }

      if (contentType.presence_status) {
        label = `${label} (${contentType.presence_status}) `;
      }

      return label;
    };

    // const paymentStatusColor = (uuid, array, field) => {
    //   const contentType = array.find(val => val[props.field] === uuid);
    //   if (!contentType || !contentType.paymentColor) {
    //     return null;
    //   }
    //   return `background-color: ${contentType[field]}`;
    // };

    const customerAge = (uuid, contentTypes, field) => {
      const contentType = contentTypes.find(val => val[props.field] === uuid);
      if (!contentType || !contentType[field]) {
        return null;
      }
      return contentType[field];
    };

    const closeConfirmationModal = () => {
      showConfirmationModal.value = false;
    };

    const closeRestoreStockModal = () => {
      restoreStockModal.value = false;
    };

    /**
     *singleSession means if we want to delete participant from single session or for all
     */
    const deleteContent = async (clubVerification = false) => {
      if (!store.getters.canUserPerformAction) {
        return;
      }

      if(isClubParticipant.value && !clubVerification){
        if(typeOfupdate.value === 'SINGLE' && isPastSession.value){
          restoreStockModal.value = true;
          closeConfirmationModal();
          return;
        }

        if(typeOfupdate.value !== 'SINGLE'){
          sessionsToUpdate.value = await constructSessionsBag(typeOfupdate.value, props.session);

          const sessionsWithParticipant = (sessionsToUpdate.value || []).filter(s => (s.participants || []).some(p => p.uuid === props.content[props.wtype] && props.content.contract_number && props.content.contract_number === p.contract_number));
          const pastSessionsWithParticipant = sessionsWithParticipant.filter(s => isBefore(new Date(s.end_time * 1000), new Date()));

          if(pastSessionsWithParticipant && pastSessionsWithParticipant.length > 0){
            sessionsToRestoreStock.value.totalSessions = sessionsWithParticipant.length;
            sessionsToRestoreStock.value.totalStockToRestore = pastSessionsWithParticipant.length;
            restoreStockModal.value = true;
            closeConfirmationModal();
            return;
          }
        }
      }

      if(typeOfupdate.value === 'SINGLE' && props.wtype !== 'participant'){
        deleteParticipantHorsePair();
        return;
      }

      if (props.wtype === 'horse' && props.session.recurring && canDeleteHorsesRecurring.value) {
        isComponentLoading.value = true;
        await deleteContentsFromSession(props.session, participantHorseList.value[props.index].horse, typeOfupdate.value, 'horses');
        isComponentLoading.value = false;
        closeConfirmationModal();
        return;
      }

      isComponentLoading.value = true;
      await deleteContentsFromSession(props.session, participantHorseList.value[props.index].participant, typeOfupdate.value, 'participants');
      isComponentLoading.value = false;
      closeConfirmationModal();
    };

    const isContentDisable = () => {
      const sessionParticipant = (props.session.participants || []).find(p => p.uuid === participantHorseList.value[props.index].participant);

      if (sessionParticipant) {
        return sessionParticipant.presence_status === presenseStatus.ABSENT;
      }

      return false;
    };

    const canUserPerformAction = computed(() => store.getters.canUserPerformAction);

    const editOverlayOptions = computed(() => {
      if (sessionsWithPeriods.includes(session.value.type)) {
        return stageRadioOptions;
      }
      return deleteOptions;
    });

    const sessionHoursDuration = computed(() => {
      const start = new Date(session.value.start_time * 1000);
      const end = new Date(session.value.end_time * 1000);
      return differenceInHours(end, start);
    });

    const effortRules = computed(() => [
      v => v <= sessionHoursDuration.value || 'L\'effort de temps du cheval ne peut pas dépasser la durée de la séance',
      v => v >= 0 || 'L\'effort du cheval ne peut pas être négatif'
    ]);

    const openHorseEffortModal = uuid => {
      if (!store.getters.canUserPerformAction) {
        return;
      }
      selectedHorse.value = uuid;
      updateEffort(uuid);

      isHorseEffortOpen.value = true;
    };

    const closeHorseEffortModal = () => {
      isHorseEffortOpen.value = false;
    };

    const addManualEffort = async uuid => {
      if (!store.getters.canUserPerformAction) {
        return;
      }
      if (!manualHorseEffort.value) {
        return;
      }
      const floatEffort = parseFloat(manualHorseEffort.value);
      if (floatEffort < 0 || floatEffort > sessionHoursDuration.value) {
        return;
      }
      const auxSession = { ...session.value };
      const index = auxSession.horses.findIndex(h => h.uuid === uuid);
      if (index !== -1) {
        auxSession.horses[index].effort = parseFloat(manualHorseEffort.value);
        loading.value = true;
        await updateSessionAmplify({ id: auxSession.id, horses: auxSession.horses });
        loading.value = false;
        sendNotification('success', 'Effort du cheval mis à jour avec succès!');
        closeHorseEffortModal();
      }
    };

    const openPresenceConfirmationModal = () => {
      presenceConfirmationModal.value = true;
    };

    const closePresenceConfirmationModal = () => {
      presenceConfirmationModal.value = false;
    };

    const setPresenceContent = async (content, status) => {
      selectedParticipant.value = content;
      presenceStatus.value = status;
      if (status !== 'present' && !content.isClubParticipant) {
        openPresenceConfirmationModal();
      } else {
        await sessionPresenceChanged();
      }
    };

    const getHorsedetail = uuid => store.getters.horse(uuid);

    const contentTypeDailyEffort = computed(() => uuid => {
      const horse = getHorsedetail(uuid);
      const dailySessions = store.getters.dailySessionsByContentType(horse);
      return { dailyEffort: minutesToHours(computeEffort(dailySessions, horse)) };
    });

    return {
      loading,
      effortValid,
      effortRules,
      sessionTypesAllowInsertEffort,
      selectedHorse,
      manualHorseEffort,
      addManualEffort,
      isHorseEffortOpen,
      openHorseEffortModal,
      closeHorseEffortModal,
      presenceStatus,
      selectedParticipant,
      closePresenceConfirmationModal,
      presenceConfirmationModal,
      sessionPresenceChanged,
      editOverlayOptions,
      canUserPerformAction,
      isContentDisable,
      changeEditSessionOverlay,
      deleteContent,
      handleDelete,
      closeConfirmationModal,
      showConfirmationModal,
      newValue,
      notSelectedList,
      dragStartPickers,
      drop,
      deleteParticipantHorsePair,
      label,
      horses,
      participantHorseList,
      updateSession,
      contentTypeDailyEffort,
      customerAge,
      isParticipant,
      setPresenceContent,
      restoreStockModal,
      closeRestoreStockModal,
      sessionsToRestoreStock,
      typeOfupdate,
      validParticipantPage,
      redirectParticipantPage
    };
  }
};
</script>
